"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressCircle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const utils_1 = require("./utils");
const typography_1 = require("../../shared/typography");
const validatePercentCircleValue = (percent) => {
    if (percent > 100)
        return 100;
    if (percent < 0)
        return 0;
    return percent;
};
const calcProgressCircleValues = (sqSize, strokeWidth, percent) => {
    const radius = (sqSize - strokeWidth) / 2;
    const dashArray = radius * Math.PI * 2;
    const dashOffset = dashArray - (dashArray * percent) / 100;
    return {
        radius,
        dashArray,
        dashOffset
    };
};
const ProgressCircle = ({ title, percent, subTitle, status }) => {
    const sqSize = 100;
    const { radius, dashOffset, dashArray } = calcProgressCircleValues(sqSize, 4, validatePercentCircleValue(percent));
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)(SVG, { viewBox: `0 0 ${sqSize} ${sqSize}`, color: (0, utils_1.resolveColor)(status), dashArray: dashArray, dashOffset: isNaN(dashOffset) ? 0 : dashOffset, children: [(0, jsx_runtime_1.jsx)("circle", { cx: sqSize / 2, cy: sqSize / 2, r: radius }, void 0), (0, jsx_runtime_1.jsx)("circle", { cx: sqSize / 2, cy: sqSize / 2, r: radius, transform: `rotate(-90 ${sqSize / 2} ${sqSize / 2})` }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: title }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: subTitle }, void 0)] }, void 0)] }, void 0));
};
exports.ProgressCircle = ProgressCircle;
const Wrapper = styled_components_1.default.div `
  position: relative;

  & > div {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    position: absolute;
    top: -3px;
    left: 0;
    width: 100%;
  }

  p,
  h4 {
    color: ${({ theme }) => theme.colors.greyBase};
    font-weight: 400;
    margin-bottom: 0;
  }

  h4 {
    font-size: 0.875rem;
  }

  p {
    font-size: 0.75rem;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    p,
    h4 {
      font-size: 0.875rem;
    }
  }
`;
const SVG = styled_components_1.default.svg `
  circle:first-of-type {
    fill: none;
    stroke: ${({ theme }) => theme.colors.silverBase};
    stroke-width: 4px;
  }

  circle:last-of-type {
    fill: none;
    stroke-dasharray: ${({ dashArray }) => dashArray};
    stroke-dashoffset: ${({ dashOffset }) => dashOffset};
    stroke: ${({ color }) => color};
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 4px;
  }
`;
//# sourceMappingURL=ProgressCircle.js.map